import {AsyncPipe, DatePipe} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {Asset, AssetService} from '@app/asset';
import {MarkdownTextareaComponent} from '@app/shared/markdown-textarea/markdown-textarea.component';
import {MarkedPipe} from '@app/shared/marked.pipe';
import {User} from '@app/shared/user.service';
import {Observable} from 'rxjs';
import {debounceTime, filter, map} from 'rxjs/operators';

@Component({
    selector: 'frog-asset-inspector',
    templateUrl: './asset-inspector.component.html',
    styleUrls: ['./asset-inspector.component.scss'],
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MarkdownTextareaComponent,
        MatIcon,
        AsyncPipe,
        DatePipe,
        MarkedPipe,
    ],
})
export class AssetInspectorComponent implements OnInit {
    @Input() asset: Asset;
    @Input() user: User;

    public form: UntypedFormGroup;
    public dirty$: Observable<any>;

    private initialValue: any;

    constructor(
        private assetService: AssetService,
        private formBuilder: UntypedFormBuilder,
    ) {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            description: '',
        });
    }

    ngOnInit(): void {
        this.initialValue = {
            name: this.asset.name,
            description: this.asset.description,
        };
        this.form.setValue(this.initialValue);
        this.dirty$ = this.form.valueChanges.pipe(
            filter((formValue) => {
                return (
                    formValue.name !== this.initialValue.name ||
                    formValue.description !== this.initialValue.description
                );
            }),
            debounceTime(1000),
            map(() => this.save()),
        );
    }

    save() {
        this.assetService.updateAsset(this.asset.id, this.form.value);
    }
}
